export default __webpack_public_path__ + "static/anneke-18702e73248774b7a05139f26b4bd034.jpg";